import { prefetchWithChunkRetry } from './lazyWithRetry';

/** Warm route chunks on nav hover so navigation can mount the page loader immediately. */
export function prefetchRoute(path: string | undefined): void {
  if (!path) return;
  if (path === '/') {
    prefetchWithChunkRetry(() => import('../components/dashboard/DashboardPage'));
    return;
  }
  if (path.startsWith('/planning')) {
    prefetchWithChunkRetry(() => import('../routes/PlanningRoute'));
    const sub = path.replace(/^\/planning\/?/, '').split(/[?#]/)[0];
    if (!sub || sub === 'io-plans' || sub.startsWith('io-plans')) {
      prefetchWithChunkRetry(() => import('../components/budget-planning/IOPlansList'));
      return;
    }
    if (sub.startsWith('io-requests')) {
      prefetchWithChunkRetry(() => import('../components/budget-planning/io-requests/IORequestsPage'));
      return;
    }
    if (sub.startsWith('bridges')) {
      prefetchWithChunkRetry(() => import('../components/budget-planning/BridgeBuilderPage'));
      return;
    }
    if (sub.startsWith('one-pagers')) {
      prefetchWithChunkRetry(() => import('../components/budget-planning/OnePagersPage'));
      return;
    }
    // DISABLED: Pull Forwards prefetch (see docs/DISABLED_FEATURES.md #17)
    // if (sub.startsWith('pull-forwards')) {
    //   prefetchWithChunkRetry(() => import('../components/budget-planning/PullForwardsPage'));
    //   return;
    // }
    if (sub.startsWith('recharges')) {
      prefetchWithChunkRetry(() => import('../components/budget-planning/RechargePlanningPage'));
      return;
    }
    if (sub.startsWith('te')) {
      prefetchWithChunkRetry(() => import('../components/current-expense/TEView'));
    }
    return;
  }
  // DISABLED: Current Expense prefetch (see docs/DISABLED_FEATURES.md Feature #11)
  // if (path.startsWith('/expense')) {
  //   prefetchWithChunkRetry(() => import('../components/current-expense/CurrentExpensePage'));
  //   return;
  // }
  if (path.startsWith('/admin')) {
    prefetchWithChunkRetry(() => import('../components/admin/AdminPage'));
  }
}
